import firebaseApp from '../../utils/firebase'
import TimeMe from 'timeme.js'
import md5 from 'md5'

const ViewState = {
  'prechat': 1,
  'queued': 2,
  'engaged': 3,
  'ended': 4
}

function capitalize(v) {
  return v.replace(/\w\S*/g, function(s) {
    return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();
  })
}

export default {
  cancelEnd({
    getters,
    dispatch
  }) {

    const trigger = {
      1: 'setPrechatState',
      2: 'setQueuedState',
      3: 'setEngagedState'
    }
    const lastState = getters.getSession.served_at ? 3 : getters.getSession.queued_at ? 2 : 1
    //console.log(trigger[lastState], lastState)

    dispatch(trigger[lastState])

    if (getters.bindSID)
      firebaseApp.ref.child('sessions')
      .child(getters.bindSID)
      .child('rated_at')
      .remove()


  },
  setViewState({
    getters
  }, v) {

    if (getters.bindSID)
      firebaseApp.ref.child('sessions')
      .child(getters.bindSID)
      .child('view_state')
      .set(v)

  },
  setPrechatState({
    getters
  }) {

    if (getters.bindSID)
      firebaseApp.ref.child('sessions')
      .child(getters.bindSID)
      .child('view_state')
      .set(ViewState['prechat'])

  },
  setQueuedState({
    getters,
    dispatch
  }) {

    //add all queue actions here

    const sid = getters.bindSID

    if (!sid)
      return

    if (!getters.getSession.queued_at) {

      //initialize data
      firebaseApp.ref.child('sessions')
        .child(sid)
        .update({
          view_state: ViewState['queued'],
          state: ViewState['queued'],
          queued_at: firebaseApp.TIMESTAMP,
          queued_on: getters.getTotalTimeOn,
          sent_offline: !getters.isOnline ? true : null
        })

      //push notifications request chat
      //add condition not to run if roundrobin is on and widget is online
      if (!(getters.doRoundRobin && getters.isOnline))
        dispatch('postNotify', {
          code: 2
        })

      //add roundrobin here
      if (getters.doRoundRobin && getters.isOnline)
        firebaseApp.roundRobin.push({
          created: firebaseApp.TIMESTAMP,
          org_id: getters.getOrgId,
          sid,
          team: getters.getSession.team || false,
          teams: getters.getSession.teams,
        })

      //push system message for prechat
      let message = getters.getPreChatLabels.message_received
      if (message)
        dispatch('jsPostMessage', {
          message
        })

    } else
      dispatch('setViewState', ViewState['queued'])

    dispatch('postEvent', {
      type: 'joined'
    })

  },
  setEngagedState({
    getters,
    dispatch
  }) {

    if (getters.bindSID)
      firebaseApp.ref.child('sessions')
      .child(getters.bindSID)
      .child('view_state')
      .set(ViewState['engaged'])

    dispatch('postEvent', {
      type: 'joined'
    })

  },
  setReopenedState({
    getters
  }) {
    const sid = getters.bindSID

    if (!sid)
      return

    const lastState = getters.getSession.ended_at - getters.getSession.served_at > 500 ? ViewState['engaged'] : ViewState['queued']

    firebaseApp.ref.child('sessions')
      .child(sid)
      .update({
        state: lastState,
        updated_at: firebaseApp.TIMESTAMP
      })
  },
  setEndState({
    getters,
    dispatch
  }) {

    //add all queue actions here

    const sid = getters.bindSID

    if (!sid)
      return

    firebaseApp.ref.child('sessions')
      .child(sid)
      .update({
        view_state: ViewState['ended'],
        left_at: firebaseApp.TIMESTAMP,
        left_on: getters.getTotalTimeOn
      })

    dispatch('postEvent', {
      type: 'left'
    }).then(msgKey => {

      dispatch('postIntegration', {
        msgKey,
        isNew: (typeof getters.getSession.queued_at === 'undefined'),
        type: 'visitor_left'
      })

    })


  },
  submitRate({
    getters,
    dispatch
  }, {
    rate,
    comment
  }) {

    if (getters.bindSID)
      firebaseApp.ref.child('sessions')
      .child(getters.bindSID)
      .child('rated_at')
      .set(firebaseApp.TIMESTAMP)

    if (rate && [-1, 1, 2].indexOf(rate) >= 0)
      dispatch('postEvent', {
        type: 'rated',
        info: {
          rate
        }
      }).then(msgKey => {

        dispatch('postIntegration', {
          msgKey,
          isNew: false,
          type: 'rate'
        })

      })

    if (comment &&
      comment.trim())
      dispatch('postEvent', {
        type: 'comment',
        info: {
          message: comment
        }
      }).then(msgKey => {

        dispatch('postIntegration', {
          msgKey,
          isNew: false,
          type: 'comment'
        })

      })

  },
  setRate({
    getters
  }, v) {

    if (getters.bindSID)
      firebaseApp.ref.child('sessions')
      .child(getters.bindSID)
      .child('rate')
      .set(v)

  },
  submitAdvanceRate({
    getters,
    dispatch
  }, {
    data,
    comment
  }) {

    if (getters.bindSID)
      firebaseApp.ref
        .child('sessions')
        .child(getters.bindSID)
        .child('rated_at')
        .set(firebaseApp.TIMESTAMP)

    let qa = Object.keys(data).map((key)=>data[key])
    let count = qa.filter((curr)=>curr > 0).length
    let sum = qa.reduce((sum,curr)=>sum+curr)

    let rateData = {
      filled: count ? true : false,
      sum,
      count,
      ave: sum/count,
      scores: data
    }

    firebaseApp.ref
      .child('sessions')
      .child(getters.bindSID)
      .child('advance_rate')
      .set(rateData)

    if (count)
    dispatch('postEvent', {
      type: 'advanceRated',
      info: {
        rate: rateData.ave
      }
    })
    .then(msgKey => {

      dispatch('postIntegration', {
        msgKey,
        isNew: false,
        type: 'rate'
      })

    })

    if (comment &&
      comment.trim())
      dispatch('postEvent', {
        type: 'comment',
        info: {
          comment
        }
      }).then(msgKey => {

        dispatch('postIntegration', {
          msgKey,
          isNew: false,
          type: 'comment'
        })

      })

  },
  saveMeta({
    getters,
    dispatch
  }, v) {

    if (typeof v !== 'object')
      return

    const emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const phoneRE = /[0-9-+]+/
    let meta = v

    //if (meta.name && !meta.name.replace())
    if (meta.phone &&
      !phoneRE.test(meta.phone)
    )
      return false

    if (meta.email &&
      !emailRE.test(meta.email)
    )
      return false

    if (meta.name) {
      meta.name = capitalize(meta.name.trim()).replace(/[!@#$%^&*()\\/,_~\?<>:;"{}=\+\[\]\|]/gi, '').replace(/[0-9]+/g, '')
      if (!meta.name)
        return false
    }

    if (meta.email && !meta.avatar) {
      let url = '//www.gravatar.com/avatar/' + md5(meta.email)
      let img = new Image()
      img.src = url + '?d=404'
      img.onload = () => {
        if (!getters.getMeta.avatar)
          dispatch('updateMeta', {
            avatar: url
          })
      }

    }

    dispatch('updateMeta', meta)

  },
  updateMeta({
    getters
  }, v) {

    if (getters.bindSID)
      firebaseApp.ref.child('sessions')
      .child(getters.bindSID)
      .child('meta')
      .update(v)

    if (getters.bindUID)
      firebaseApp.ref.child('visitors')
      .child(getters.bindUID)
      .child('meta')
      .update(v)

  },
  setTeam({
    getters
  }, v) {

    if (getters.bindSID)
      firebaseApp.ref.child('sessions')
      .child(getters.bindSID)
      .child('team')
      .set(v)

  },
  updateLobby({
    getters
  }) {

    if (getters.bindSID &&
      (getters.getViewState > 1 &&
        getters.getViewState < 4)
    )
      firebaseApp.ref
      .child('lobby')
      .child(getters.bindSID)
      .child('updated_at')
      .set(firebaseApp.TIMESTAMP)

  },
  updateTimeOn({
    getters,
    commit
  }) {
    let timeOnPage = getters.getTimeOnPage
    let currentTime = TimeMe.getTimeOnCurrentPageInSeconds()
    let timeUpdate = currentTime - timeOnPage
    commit('setLastTimeUpdate', timeUpdate)
    commit('setTimeOnPage', currentTime)

    if (getters.bindSID)
      firebaseApp.ref.child('sessions')
      .child(getters.bindSID)
      .child('time_on')
      .transaction((v) => {
        return v + timeUpdate
      })
      .catch(e => {
        // ignore, might be offline
        console.warn('Time update failed. Might be offline');
      });

  }
}
